import { render, staticRenderFns } from "./add.vue?vue&type=template&id=08830761&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=08830761&prod&lang=less&scoped=true"
import style1 from "./add.vue?vue&type=style&index=1&id=08830761&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08830761",
  null
  
)

export default component.exports